export default {
	common: {
		clearSelection: "Auswahl aufheben",
		delete: "Löschen",
		close: "Schliessen",
	},
	catalogue: {
		pendingOrdersTitle: "Offene Bestellungen",
		pendingOrdersDescription:
			"Die folgenden Bestellungen wurden von den jeweiligen Benutzern beantragt, aber noch nicht freigegeben.",
		uploadButtonTooltip: "Artikel auswählen und hochladen.",
		importTitle: "Artikel Import",
		importHint:
			"Maximal 10 Dateien (.step / .stp / .dxf) in diesen Bereich ziehen oder den Knopf drücken",
		emptyHint: "Noch etwas leer hier...",
		importInstructions:
			"Importieren Sie Ihre CAD Modelle im Format .step oder .dxf indem Sie die Dateien auf diese Fläche ziehen oder klicken Sie auf den Knopf oben, um die Dateien auszuwählen.",
		importProcessDescription:
			"Blexon importiert anschliessend Ihre Teile, prüft sie auf Machbarkeit und berechnet automatisch die Preise.",
		videoIntro: "Das Video zeigt die ersten Schritte mit Blexon",
		videoTitle:
			"So einfach laden Sie CAD Modelle zu Blexon hoch und bestellen direkt online lasergeschnittene Blechteile nach Maß",
		searchLabel: "Artikel suchen:",
		searchPlaceholder: "Artikelname oder -nummer eingeben...",
		sortingLabel: "Sortierung:",
		userFilterLabel: "Artikel anzeigen von:",
		loadMoreTooltip: "Lädt weitere Artikel mit den aktuellen Filtereinstellungen.",
		loadMoreButton: "Mehr laden",
		sortTypes: {
			createdDescending: "Neu Erstellte zuerst",
			createdAscending: "Neu Erstellte zuletzt",
			lastChangeDescending: "Zuletzt Geänderte zuerst",
			lastChangeAscending: "Zuletzt Geänderte zuletzt",
			nameAscending: "Nach Artikelname A - Z",
			nameDescending: "Nach Artikelname Z - A",
			materialNameAscending: "Nach Materialbezeichnung A - Z",
			materialNameDescending: "Nach Materialbezeichnung Z - A",
			materialThicknessAscending: "Nach Materialdicke (dünne zuerst)",
			materialThicknessDescending: "Nach Materialdicke (dicke zuerst)",
		},
		uploadWarningDialog: {
			title: "Inkompatible Dateien",
			invalidFormatText:
				"Folgende Dateien haben ein ungültiges Format und können nicht hochgeladen werden:",
			errorText:
				"Folgende Dateien überschreiten die maximal erlaubte Dateigröße und können nicht hochgeladen werden:",
			warningText:
				"Folgende Dateien sind sehr groß und werden nicht automatisch weiterverarbeitet:",
			warningHint:
				"Bitte definieren Sie für diese Artikel den passenden Werkstoff und die korrekte Dicke. Nach dem Blexonisieren werden die Artikel Ihrem Katalog hinzugefügt. Von dort können Sie die Artikel an unser Helpdesk zur Überprüfung senden.",
			moreInfo:
				"Weitere Informationen zu den erlaubten Dateigrößen und zu den Ursachen von großen CAD Modellen erhalten Sie in unserem {blog}.",
			blogLinkText: "Blog",
		},
		messages: {
			maxFilesExceeded: "Sie können maximal 10 CAD Modelle gleichzeitig hochladen.",
		},
	},
	assembly: {
		processing: "Baugruppe wird verarbeitet...",
		back: "Zurück",
		title: "Baugruppe: {articleId} | '{articleName}'",
		multiDeleteDialog: {
			title: "Mehrere Artikel löschen",
			deleting: "Artikel werden gelöscht...",
			invalidStateText:
				"Folgende Artikel sind entweder gesperrt oder werden derzeit berechnet und können deshalb {not} gelöscht werden:",
			notWord: "nicht",
			confirmText: "Möchten Sie {count} Artikel wirklich löschen?",
			noneDeletable: "Keiner der ausgewählten Artikel kann gelöscht werden.",
			deleteButton: "Löschen",
		},
		messages: {
			deleteError: "Fehler beim Löschen eines Artikels.",
		},
	},
	multiedit: {
		deleteButton: "{count} Artikel löschen",
		powderCoatButton: "{count} Artikel pulverbeschichten",
		powderCoatTooltip:
			"Für alle ausgewählten Artikel eine Pulverbeschichtung hinzufügen, bearbeiten oder entfernen.",
		zincCoatButton: "{count} Artikel verzinken",
		zincCoatTooltip:
			"Für alle ausgewählten Artikel eine Verzinkung hinzufügen, bearbeiten oder entfernen.",
	},
	multieditAssembly: {
		deleteButton: "{count} Artikel löschen",
	},
	importArticle: {
		uploading: "Wird hochgeladen...",
		articleNameLabel: "Artikelname",
		articleNumberLabel: "Artikelnummer (optional)",
		articleNumberPlaceholder: "Ihre Artikelnummer",
		quantityInAssembly: "{count} Stück",
		thickness: "Dicke: {thickness}mm",
		noMaterialFoundHintMain:
			"Wir haben kein Material mit der erkannten Dicke gefunden. Bitte wählen Sie den gewünschten Werkstoff aus der Liste und blexonisieren sie den Artikel. Sollte dabei ein Fehler auftreten, können Sie den Artikel an unser Helpdesk zur Überprüfung senden.",
		noMaterialFoundHintSubArticle:
			'Wir haben kein Material mit der erkannten Dicke gefunden. Wir empfehlen Einpressungen mit dem "Papierkorb" rechts zu löschen und anschliessend im CAD Viewer zu definieren. Auch "Nicht-Blechteile" können Sie so vor der Verarbeitung entfernen.',
		materialPlaceholder: "Bitte Werkstoff wählen...",
		thicknessPlaceholder: "Bitte Dicke wählen...",
		pressJoinPlaceholder: "... oder wählen Sie eine Einpressung",
		noPressJoinsAvailable: "Es sind keine Einpressungen verfügbar",
		deleteTooltip: "Bricht den Import-Prozess ab und löscht den Artikel aus der Liste.",
		deleteSubArticleTooltip: "Diesen Volumenkörper aus dem Modell entfernen.",
		blexonisierenButton: "Blexonisieren",
		blexonisierenTooltip:
			"Analysiert den Artikel und erkennt Bearbeitungen automatisch. Preisberechnung wird gestartet.",
		pressJoinCategories: {
			selfClinchingNuts: "Einpressmuttern",
			selfClinchingThreadedStud: "Einpressgewindebolzen",
			selfClinchingThreadedStandoff: "Einpressgewindebuchsen",
		},
		messages: {
			deleteError: "Artikel konnte nicht gelöscht werden.",
		},
	},
	importAssembly: {
		articleNameLabel: "Artikelname",
		articleNumberLabel: "Artikelnummer (optional)",
		articleNumberPlaceholder: "Ihre Artikelnummer",
		assemblyProcessingText: "Oh, eine Baugruppe. Dann zerlegen wir die mal...",
		materialPlaceholderAvailable: "Bitte Werkstoff wählen...",
		materialPlaceholderUnavailable: "Kein gemeinsamer Werkstoff für alle Teile verfügbar",
		materialHint:
			"Dieser Werkstoff ist nicht für alle Teile verfügbar. Wählen Sie bitte die fehlenden Werkstoffe unten einzeln aus.",
		deleteTooltip: "Bricht den Import-Prozess ab und löscht den Artikel aus der Liste.",
		blexonisierenButton: "Blexonisieren",
		blexonisierenTooltip:
			"Analysiert die Baugruppe und erkennt Bearbeitungen automatisch. Preisberechnung wird gestartet.",
		messages: {
			deleteError: "Artikel konnte nicht gelöscht werden.",
		},
	},
	pendingOrder: {
		summary: "Offene Bestellung vom {date} von {firstname} {lastname} ({count} Positionen)",
		addToCartTooltip: "Fügt die Bestellung dem Warenkorb hinzu.",
		addToCartButton: "In Warenkorb",
		deleteTooltip: "Löscht die Bestellung.",
		deleteDialog: {
			title: "Sind Sie sicher?",
			text: "Die Bestellung von {firstname} {lastname} mit {count} Positionen soll gelöscht werden? Dieser Vorgang kann nicht mehr rückgängig gemacht werden.",
		},
	},
};
